import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  ApplicationAppEntityApplicationRead, ApplicationAppEntityApplicationWrite,
  TreeToRemoveAppEntityTreeToRemoveWrite
} from '../../../../../../../openapi';

export function toTreeToRemoveFormValues(v: ApplicationAppEntityApplicationRead): TreeToRemoveAppEntityTreeToRemoveWrite[] {
  return v?.treesToRemove?.map(item => ({
    district: item?.district || '',
    mapSheet: item?.mapSheet || '',
    registryNumber: item?.registryNumber || '',
    species: item?.species || '',
    trunkCircumference130: item?.trunkCircumference130 || '0',
    objectType: item?.objectType,
    removalReasons: item?.removalReasons?.map(v => v.id || '') || [],
    removalFee: item?.removalFee,
    otherRemovalReason: item?.otherRemovalReason,
    landDesignation: item?.landDesignation,
    removalJustification: item?.removalJustification
  })) || [];
}

@Injectable()
export class TreesCuttingInfoForm extends AppForm {
  constructor() {
    super({
      fullName: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      postalCode: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      postOffice: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      city: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      street: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.maxLength(255)]
        }
      ),
      buildingNumber: new FormControl(
        '',
        {
          nonNullable: true,
          validators: [Validators.required, Validators.maxLength(255)]
        }
      ),
      apartmentNumber: new FormControl(
        '',
        {
          nonNullable: true,
          validators: []
        }
      ),
      intendedRemovalDate: new FormControl(null, [Validators.required, Validators.maxLength(255)]),
      treesToRemove: new FormControl<TreeToRemoveAppEntityTreeToRemoveWrite[]>(
        [], {
          nonNullable: true,
          validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
        }
      )
    });
  }

  public get treesToRemove(): FormControl {
    return this.get('treesToRemove') as FormControl;
  }

  public get treesToRemoveValues(): TreeToRemoveAppEntityTreeToRemoveWrite[] {
    return this.treesToRemove.value;
  }

  public addTreeToRemove(v: TreeToRemoveAppEntityTreeToRemoveWrite): void {
    this.treesToRemove.setValue([...this.treesToRemoveValues, v]);
  }

  public editTreeToRemove(v: TreeToRemoveAppEntityTreeToRemoveWrite, i: number): void {
    let items = [...this.treesToRemoveValues];
    items[i] = v;
    this.treesToRemove.setValue(items);
  }

  public removeTreeToRemove(i: number): void {
    this.treesToRemove.setValue(this.treesToRemoveValues.filter((_, v) => v !== i));
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      propertyOwnerFullName: this.value.fullName,
      propertyOwnerPostalCode: this.value.postalCode,
      propertyOwnerPostOffice: this.value.postOffice,
      propertyOwnerCity: this.value.city,
      propertyOwnerStreet: this.value.street,
      propertyOwnerHouseNumber: this.value.buildingNumber,
      propertyOwnerApartmentNumber: this.value.apartmentNumber,
      intendedRemovalDate: this.value?.intendedRemovalDate
    };
  }

  public override patchFormValues(app: ApplicationAppEntityApplicationRead): void {
    super.patchFormValues({
      fullName: app?.propertyOwnerFullName,
      postalCode: app?.propertyOwnerPostalCode,
      postOffice: app?.propertyOwnerPostOffice,
      city: app?.propertyOwnerCity,
      street: app.propertyOwnerStreet,
      buildingNumber: app.propertyOwnerHouseNumber,
      apartmentNumber: app.propertyOwnerApartmentNumber,
      intendedRemovalDate: app?.intendedRemovalDate
    });
    this.treesToRemove.setValue(toTreeToRemoveFormValues(app));
  }
}
